// /latency moved into Server settings → Stats → Latency (components/ServerStats.tsx), per server. Old links land on
// the first server you run; anyone else goes home.
import { Navigate } from "react-router-dom";
import { useSession } from "../session.tsx";

export function Latency() {
  const { me } = useSession();
  if (me === undefined) return null;
  const runs = me?.servers.find((s) => s.role === "owner" || s.role === "admin");
  return <Navigate to={runs ? `/s/${runs.id}/settings/latency` : "/"} replace />;
}
